import { render, staticRenderFns } from "./Weekly.vue?vue&type=template&id=3cd02f00&scoped=true"
import script from "./Weekly.vue?vue&type=script&lang=js"
export * from "./Weekly.vue?vue&type=script&lang=js"
import style0 from "./Weekly.vue?vue&type=style&index=0&id=3cd02f00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd02f00",
  null
  
)

export default component.exports